import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {continueSequence} from '/redux/action/launchSequence.action';
import {
  completedAllSteps,
  stepsStatusString,
} from '/redux/selector/launchSequence.selector';
import {generateCallback} from '/util/component.util';

import LaunchSequenceProvider from './LaunchSequenceProvider';

export default connect(
  createStructuredSelector({
    statusString: stepsStatusString,
    sequenceCompleted: completedAllSteps,
  }),
  dispatch => ({
    continueSequence: generateCallback({
      func: dispatch,
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      params: continueSequence(),
    }),
  }),
)(LaunchSequenceProvider);
